import { render, staticRenderFns } from "./app_bottom.vue?vue&type=template&id=832b696e&scoped=true"
import script from "./app_bottom.vue?vue&type=script&lang=js"
export * from "./app_bottom.vue?vue&type=script&lang=js"
import style0 from "./app_bottom.vue?vue&type=style&index=0&id=832b696e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832b696e",
  null
  
)

export default component.exports